<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
  [spinner]="spinkit.skThreeBounce">
</ng-http-loader>
<div *ngIf="expanded" class="container-min-width">
  <div>
    <button (click)="expandToggle()" class="toggle-btn">
      <img src="../../../assets/img/shrink-icon.svg" alt="" class="expand-toggle" />
    </button>
  </div>
  <div>
    <div class="sidenav-container-width">
      <div>
        <div class="d-flex">
          <div class="col-4">
            <img [src]="src" alt="" />
          </div>
          <div>
            <div class="title">{{superAdminName}}</div>
            <div class="admin-email">{{superAdminEmail}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="logo-div">&nbsp;</div>
  </div>

  <div>
    <div class="dashboard-div" (click)="goToDashboard()">
      <div class="d-flex">
        <div class="dashboard-img col-4">
          <a [routerLink]="['/superadmin/dashboard']" routerLinkActive="active" #rla="routerLinkActive">
            <img [src]="rla.isActive ? dashboardGreen : dashboardGray" alt="menu" />
          </a>
        </div>
        <div class="dashboard-title" [ngClass]="rla.isActive ? 'text-green' : 'text-gray'">
          Dashboard
        </div>
      </div>
    </div>
    <div class="logo-div">&nbsp;</div>
  </div>

  <div>
    <div class="dashboard-div" (click)="goToRestoList()">
      <div class="d-flex">
        <div class="dashboard-img col-4">
          <a [routerLink]="['/superadmin/restolist']" routerLinkActive="active" #rlar="routerLinkActive">
            <img [src]="rlar.isActive ? restoListGreen : restoListGray" alt="menu" />
          </a>
        </div>
        <div class="dashboard-title" [ngClass]="rlar.isActive ? 'text-green' : 'text-gray'">
          Restaurants
        </div>
      </div>
    </div>
    <div class="logo-div">&nbsp;</div>
  </div>

  <div>
    <div class="dashboard-div" (click)="goToAllergens()">
      <div class="d-flex">
        <div class="dashboard-img col-4">
          <a [routerLink]="['/superadmin/allergensDietary']" routerLinkActive="active" #rlaa="routerLinkActive">
            <img [src]="rlaa.isActive ? allergenGreen : allergenGray" alt="menu" />
          </a>
        </div>
        <div class="dashboard-title" [ngClass]="rlaa.isActive ? 'text-green' : 'text-gray'">
          Allergens & Dietary preferences
        </div>
      </div>
    </div>
    <div class="logo-div">&nbsp;</div>
  </div>

  <div>
    <div class="dashboard-div" (click)="goToCategory()">
      <div class="d-flex">
        <div class="dashboard-img col-4">
          <a [routerLink]="['/superadmin/categoryCuisines']" routerLinkActive="active" #rlac="routerLinkActive">
            <img [src]="rlac.isActive ? categoryGreen : categoryGray" alt="menu" />
          </a>
        </div>
        <div class="dashboard-title" [ngClass]="rlac.isActive ? 'text-green' : 'text-gray'">
          Categories & Cuisines
        </div>
      </div>
    </div>
    <div class="logo-div">&nbsp;</div>
  </div>
  <!-- --------------------------------d2 resto list--------------------------------------------- -->
  <div>
    <div class="dashboard-div" (click)="goToD2RestoList()">
      <div class="d-flex">
        <div class="dashboard-img col-4">
          <a [routerLink]="['/superadmin/d2restolist']" routerLinkActive="active" #rlad2="routerLinkActive">
            <img [src]="rlad2.isActive ? d2RestoGreen : d2RestoGray" alt="menu" />
          </a>
        </div>
        <div class="dashboard-title" [ngClass]="rlad2.isActive ? 'text-green' : 'text-gray'">Claimed Restaurants</div>
      </div>
    </div>
    <div class="logo-div">&nbsp;</div>
  </div>
  <!-- --------------------------------End--------------------------------------------- -->
  <!-- ----------------------------------Nutrilable------------------------------------------------------------------------ -->
  <div>
    <div class="dashboard-div" (click)="goToNutrilabelDish()">
      <div class="d-flex">
        <div class="dashboard-img col-4">
          <a [routerLink]="['/superadmin/nutri-label']" routerLinkActive="active" #rlnl="routerLinkActive">
            <img [src]="rlnl.isActive ? nutriLabelRestoGreen : nutriLabelRestoGray" alt="menu" />
          </a>
        </div>
        <div class="dashboard-title" [ngClass]="rlnl.isActive ? 'text-green' : 'text-gray'">Recipe</div>
      </div>
    </div>
    <div class="logo-div">&nbsp;</div>
  </div>
  <!-- --------------------------------------------End------------------------------------------------------------ -->
  <!-- --------------------------------------Weekly top ten------------------------------------------------------------ -->
  <div>
    <div class="dashboard-div" (click)="goToWeeklyTen()">
      <div class="d-flex">
        <div class="dashboard-img col-4">
          <a [routerLink]="['/superadmin/weeklyUpdate']" routerLinkActive="active" #rltt="routerLinkActive">
            <img [src]="rltt.isActive ? weeklyTenGreen : weeklyTenGray" alt="menu" />
          </a>
        </div>
        <div class="dashboard-title" [ngClass]="rltt.isActive ? 'text-green' : 'text-gray'">Weekly Ten</div>
      </div>
    </div>
    <div class="logo-div">&nbsp;</div>
  </div>
  <!-- --------------------------------------------End------------------------------------------------------------ -->
  
  <div>
    <div class="dashboard-div" (click)="goToEmailTemplate()">
      <div class="d-flex">
        <div class="dashboard-img col-4">
          <a [routerLink]="['/superadmin/emailTemplate']" routerLinkActive="active" #rlaet="routerLinkActive">
            <img [src]="rlaet.isActive ? emailTemplateGreen : emailTemplateGray" alt="menu" />
          </a>
        </div>
        <div class="dashboard-title" [ngClass]="rlaet.isActive ? 'text-green' : 'text-gray'">Email Template</div>
      </div>
    </div>
    <div class="logo-div">&nbsp;</div>
  </div>

  <div>
    <div class="dashboard-div" (click)="goToRegulatoryAndPlan()">
      <div class="d-flex">
        <div class="dashboard-img col-4">
          <a [routerLink]="['/superadmin/regulatoryAndPlan']" routerLinkActive="active" #rlraep="routerLinkActive">
            <img [src]="rlraep.isActive ? infoEventGreen : infoEventGray" alt="menu" />
          </a>
        </div>
        <div class="dashboard-title" [ngClass]="rlraep.isActive ? 'text-green' : 'text-gray'">Regulatory Info & Event Plan</div>
      </div>
    </div>
    <div class="logo-div">&nbsp;</div>
  </div>


  <div>
    <div class="dashboard-div" (click)="goToAccountSetting()">
      <div class="d-flex">
        <div class="dashboard-img col-4">
          <a [routerLink]="['/superadmin/accountSetting']" routerLinkActive="active" #rlas="routerLinkActive">
            <img [src]="rlas.isActive ? settingGreen : settingGray" alt="menu" />
          </a>
        </div>
        <div class="dashboard-title" [ngClass]="rlas.isActive ? 'text-green' : 'text-gray'">Account Setting</div>
      </div>
    </div>
    <div class="logo-div">&nbsp;</div>
  </div>
  <div>
    <div class="dashboard-div" (click)="logout()">
      <div class="d-flex">
        <div class="dashboard-img col-4">
          <img src="../../../assets/img/logout.svg" alt="" />
        </div>
        <div class="dashboard-title">Logout</div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!expanded">
  <div>
    <button (click)="expandToggle()" class="toggle-btn-shrink">
      <img src="../../../assets/img/expand-icon.svg" alt="" class="expand-toggle" />
    </button>
  </div>

  <div class="sidenav-container-width">
    <div class="logo-bottom-div">
      <img [src]="src" alt="" />
    </div>
  </div>
  <div class="logo-div">&nbsp;</div>

  <div>
    <div (click)="goToDashboard()">
      <div class="dashboard-img-shrinked">
        <a [routerLink]="['/superadmin/dashboard']" routerLinkActive="active" #rla="routerLinkActive">
          <img [src]="rla.isActive ? dashboardGreen : dashboardGray" alt="menu" />
        </a>
      </div>
    </div>
    <div class="logo-div">&nbsp;</div>
  </div>

  <div>
    <div class="dashboard-div" (click)="goToRestoList()">
      <div class="d-flex">
        <div class="dashboard-img-shrinked">
          <a [routerLink]="['/superadmin/restolist']" routerLinkActive="active" #rlar="routerLinkActive">
            <img [src]="rlar.isActive ? restoListGreen : restoListGray" alt="menu" />
          </a>
        </div>
      </div>
    </div>
    <div class="logo-div">&nbsp;</div>
  </div>

  <div>
    <div class="dashboard-div" (click)="goToAllergens()">
      <div class="d-flex">
        <div class="dashboard-img-shrinked">
          <a [routerLink]="['/superadmin/allergensDietary']" routerLinkActive="active" #rlaa="routerLinkActive">
            <img [src]="rlaa.isActive ? allergenGreen : allergenGray" alt="menu" />
          </a>
        </div>
      </div>
    </div>
    <div class="logo-div">&nbsp;</div>
  </div>

  <div>
    <div class="dashboard-div" (click)="goToCategory()">
      <div class="d-flex">
        <div class="dashboard-img-shrinked">
          <a [routerLink]="['/superadmin/categoryCuisines']" routerLinkActive="active" #rlac="routerLinkActive">
            <img [src]="rlac.isActive ? categoryGreen : categoryGray" alt="menu" />
          </a>
        </div>
      </div>
    </div>
    <div class="logo-div">&nbsp;</div>
  </div>
  <!-- --------------------------------d2 resto list toggle--------------------------------------------- -->
  <div>
    <div class="dashboard-div" (click)="goToD2RestoList()">
      <div class="d-flex">
        <div class="dashboard-img-shrinked">
          <a [routerLink]="['/superadmin/d2restolist']" routerLinkActive="active" #rlad2="routerLinkActive">
            <img [src]="rlad2.isActive ? d2RestoGreen : d2RestoGray" alt="menu" />
          </a>
        </div>
      </div>
      <div class="logo-div">&nbsp;</div>
    </div>
    <!-- --------------------------------End--------------------------------------------- -->
    <!-- ----------------------------------Nutrilable------------------------------------------------------------------------ -->
    <div class="dashboard-div" (click)="goToNutrilabelDish()">
      <!-- <div class="dashboard-img-shrinked ">
                        <img src="../../../assets/img/account-setting.svg" alt="">
                    </div> -->
      <div class="d-flex">
        <div class="dashboard-img-shrinked">
          <a [routerLink]="['/superadmin/nutri-label']" routerLinkActive="active" #rlnl="routerLinkActive">
            <img [src]="rlnl.isActive ? nutriLabelRestoGreen : nutriLabelRestoGray" alt="menu" />
          </a>
        </div>
      </div>
      <div class="logo-div">&nbsp;</div>
    </div>
    <!-- --------------------------------------------End------------------------------------------------------------ -->
    <!-- ----------------------------------------Weekly top ten------------------------------------------------------------ -->
    <div class="dashboard-div" (click)="goToWeeklyTen()">
      <div class="d-flex">
        <div class="dashboard-img-shrinked">
          <a [routerLink]="['/superadmin/weeklyUpdate']" routerLinkActive="active" #rltt="routerLinkActive">
            <img [src]="rltt.isActive ? weeklyTenGreen : weeklyTenGray" alt="menu" />
          </a>
        </div>
      </div>
      <div class="logo-div">&nbsp;</div>
    </div>
    <!-- --------------------------------------------End------------------------------------------------------------ -->

    <div>
      <div class="dashboard-div" (click)="goToAccountSetting()">
        <!-- <div class="dashboard-img-shrinked ">
                    <img src="../../../assets/img/account-setting.svg" alt="">
                </div> -->
        <div class="d-flex">
          <div class="dashboard-img-shrinked">
            <a [routerLink]="['/superadmin/accountSetting']" routerLinkActive="active" #rlas="routerLinkActive">
              <img [src]="rlas.isActive ? settingGreen : settingGray" alt="menu" />
            </a>
          </div>
        </div>
        <div class="logo-div">&nbsp;</div>
      </div>

      <div>
        <div class="dashboard-div" (click)="logout()">
          <div class="d-flex">
            <div class="dashboard-img-shrinked">
              <img src="../../../assets/img/logout.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>